export enum AccountType {
  Sido = 1,
  PaOrMsp = 2,
}
